import { SvgIcon } from '@mui/material';

export function RefreshIcon(props) {
	return (
		<SvgIcon
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				d="M5.44703 10.667C5.69417 9.51693 6.23709 8.44081 7.0291 7.56902C7.83667 6.67777 8.8797 6.01809 10.0317 5.67171C11.1682 5.33117 12.3883 5.29419 13.5403 5.5822C14.6495 5.85852 15.6789 6.41896 16.5098 7.20318C17.3582 8.00297 17.9848 9.02071 18.3157 10.1396C18.3585 10.2875 18.3974 10.4354 18.4324 10.5853C18.4869 10.8285 18.8625 10.7254 18.808 10.4821C18.5317 9.2659 17.9362 8.13529 17.0839 7.22459C16.2607 6.34696 15.2119 5.68728 14.0637 5.32338C12.8728 4.94587 11.5904 4.90111 10.3742 5.17744C9.13268 5.46155 7.97873 6.08815 7.06412 6.97161C6.17677 7.82978 5.52098 8.92535 5.18433 10.1143C5.14152 10.2622 5.10649 10.4121 5.07341 10.5619C5.02087 10.8071 5.39449 10.9122 5.44703 10.667Z"
				fill="none"
				stroke="currentColor"
				strokeLinejoin="round"
				strokeWidth="1.5"
			/>
			<path
				d="M19.4284 7.64683C19.1384 8.47581 18.8485 9.30673 18.5585 10.1357C18.5177 10.2525 18.4768 10.3692 18.4359 10.4879C18.5157 10.4432 18.5955 10.3965 18.6753 10.3517C17.8463 10.0618 17.0154 9.77182 16.1864 9.48187C16.0696 9.44101 15.9529 9.40014 15.8342 9.35927C15.7349 9.32425 15.6221 9.39819 15.5948 9.49549C15.5656 9.60252 15.6318 9.69982 15.7311 9.73484C16.56 10.0248 17.391 10.3147 18.2199 10.6047C18.3367 10.6456 18.4534 10.6864 18.5722 10.7273C18.6753 10.7643 18.7784 10.6845 18.8115 10.5911C19.1015 9.76209 19.3914 8.93116 19.6813 8.10219C19.7222 7.98543 19.7631 7.86867 19.8039 7.74997C19.839 7.65072 19.765 7.53786 19.6677 7.51061C19.5607 7.48142 19.4634 7.54564 19.4284 7.64683Z"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
			<path
				d="M18.5538 13.3328C18.3067 14.4829 17.7638 15.559 16.9718 16.4308C16.1642 17.322 15.1212 17.9817 13.9692 18.3281C12.8327 18.6686 11.6126 18.7056 10.4606 18.4176C9.3514 18.1413 8.32199 17.5808 7.49106 16.7966C6.64263 15.9968 6.01603 14.9791 5.68521 13.8601C5.6424 13.7123 5.60348 13.5644 5.56846 13.4145C5.51397 13.1713 5.1384 13.2744 5.19289 13.5177C5.46921 14.7339 6.06468 15.8645 6.91701 16.7752C7.74015 17.6528 8.78902 18.3125 9.93713 18.6764C11.1281 19.0539 12.4104 19.0987 13.6267 18.8223C14.8682 18.5382 16.0221 17.9116 16.9367 17.0282C17.8241 16.17 18.4799 15.0744 18.8165 13.8854C18.8594 13.7376 18.8944 13.5877 18.9275 13.4379C18.982 13.1927 18.6064 13.0876 18.5538 13.3328Z"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.5"
			/>
			<path
				d="M4.57191 16.3549C4.86186 15.5259 5.1518 14.695 5.44175 13.866C5.48262 13.7493 5.52348 13.6325 5.56435 13.5138C5.48456 13.5585 5.40478 13.6053 5.32499 13.65C6.15397 13.94 6.9849 14.2299 7.81388 14.5199C7.93063 14.5607 8.04739 14.6016 8.1661 14.6424C8.26534 14.6775 8.3782 14.6035 8.40545 14.5062C8.43464 14.3992 8.36847 14.3019 8.26923 14.2669C7.44025 13.9769 6.60933 13.687 5.78035 13.397C5.66359 13.3562 5.54683 13.3153 5.42813 13.2744C5.32499 13.2375 5.22186 13.3172 5.18878 13.4107C4.89883 14.2396 4.60888 15.0706 4.31893 15.8995C4.27807 16.0163 4.2372 16.1331 4.19634 16.2518C4.16131 16.351 4.23526 16.4639 4.33256 16.4911C4.43958 16.5203 4.53688 16.4541 4.57191 16.3549Z"
				fill="none"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinejoin="round"
			/>
		</SvgIcon>
	);
}
